module.exports = __webpack_public_path__ + "static/media/048-forbidden.98a5a68f.svg";